import React from 'react'
import cn from 'classnames'

import { useDropdown } from '@hooks/useDropdown'
import { DragIndicatorIcon } from '@components/icons/DragIndicatorIcon'
import { WritingListStatusEnum } from '@interfaces/WritingListStatusEnum'
import { SelectPerPageProps } from './interface'

const ButtonSelectStatus = ({
  id,
  options,
  className,
  title,
  handleSelect,
}: SelectPerPageProps) => {
  const { dropdownRef, isShowDropdown, toggleDropdown } = useDropdown()

  return (
    <div ref={dropdownRef} className={cn('relative', className)}>
      <button
        data-test={`action-${title}`}
        type='button'
        className={cn(
          'border border-gray-3 dark:border-dark-9 bg-white dark:bg-dark-9 rounded-[8px] px-[4px] h-[30px]',
          {
            'border-primary': isShowDropdown,
          }
        )}
        onClick={toggleDropdown}
      >
        <div className='flex'>
          <DragIndicatorIcon
            width='20'
            height='20'
            className={cn('', {
              'text-primary': isShowDropdown,
              'text-secondary-1 dark:text-dark-10': !isShowDropdown,
            })}
          />
        </div>
      </button>
      <div
        className={cn(
          'absolute w-fit min-w-[150px] z-10 text-[14px] font-light text-secondary dark:text-dark-10 mt-[5px] right-0 bg-white dark:bg-dark-9 border border-gray-4 dark:border-purple rounded-[8px] shadow-dropdown',
          { hidden: !isShowDropdown }
        )}
      >
        {options.map((row, index) => (
          <div
            data-test={`delete-${title}`}
            className='whitespace-nowrap flex items-center hover:bg-primary-1 dark:hover:bg-dark hover:text-primary dark:hover:text-dark-10 cursor-pointer py-[10px] px-[10px] rounded-[8px]'
            key={index}
            onClick={() => {
              handleSelect(id, row.value)
              toggleDropdown()
            }}
          >
            {row.icon ? (
              row.icon
            ) : (
              <div
                className={cn('h-[10px] w-[10px] mr-[10px] rounded-full', {
                  'bg-primary': row.value === WritingListStatusEnum.PUBLISHED,
                  'bg-secondary-1': row.value === WritingListStatusEnum.DRAFT,
                  'bg-red': row.value === WritingListStatusEnum.DELETE,
                })}
              />
            )}
            {row.label}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ButtonSelectStatus
